import { render, staticRenderFns } from "./select-city.vue?vue&type=template&id=51060a04&scoped=true"
import script from "./select-city.vue?vue&type=script&lang=js"
export * from "./select-city.vue?vue&type=script&lang=js"
import style0 from "./select-city.vue?vue&type=style&index=0&id=51060a04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51060a04",
  null
  
)

export default component.exports